import { useState, useEffect, useContext } from 'react';
import { API_URL } from '../config';
import EventContext from '../contexts/EventContext';
import useApiUrlTranslation from '../components/useApiUrlTranslation';

const useFetchPartenaireList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { currentEvent } = useContext(EventContext);
    const { apiUrlTranslation } = useApiUrlTranslation();

    useEffect(() => {
        const fetchData = async () => {
            if (!currentEvent?.id_event || !apiUrlTranslation) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);

                // 1. Récupérer les partenaires
                const partenairesUrl = `${API_URL}?action=getPartenaires&params= AND id_event=${currentEvent.id_event} AND cf.statut=143`;
                const partenairesResponse = await fetch(partenairesUrl);
                const partenairesData = await partenairesResponse.json();

                if (!Array.isArray(partenairesData)) {
                    throw new Error("Le format des données des partenaires est incorrect.");
                }

                const uniquePartenaires = Array.from(new Map(partenairesData.map(p => [p.contact.id_contact, p])).values());

                if (uniquePartenaires.length === 0) {
                    setData([]);
                    setLoading(false);
                    return;
                }

                // 2. Extraire les IDs des contacts
                const contactIds = uniquePartenaires.map(p => p.contact.id_contact);

                // 3. Récupérer les prestations correspondantes
                const prestasUrl = `${apiUrlTranslation}?action=getPrestaList&params= WHERE id_contact IN (${contactIds.join(',')})`;
                const prestasResponse = await fetch(prestasUrl);
                const prestasData = await prestasResponse.json();

                if (!Array.isArray(prestasData)) {
                    throw new Error("Le format des données des prestations est incorrect.");
                }

                // 4. Créer une Map des prestations pour une recherche efficace
                const prestasMap = new Map(prestasData.map(presta => [presta.id_contact, presta]));

                // 5. Fusionner les partenaires avec leurs prestations
                const mergedData = uniquePartenaires.map(partenaire => {
                    const presta = prestasMap.get(partenaire.contact.id_contact);
                    return {
                        ...partenaire,
                        presta_nom: presta?.presta_nom || 'N/A',
                        presta_accroche: presta?.presta_accroche || 'N/A',
                        punchline: presta?.punchline || 'N/A',
                    };
                });

                setData(mergedData);

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentEvent, apiUrlTranslation]);

    return { data, loading, error };
};

export default useFetchPartenaireList;